import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};

const getInitialLanguage = (): string => {
  try {
    const cookieSettings = document.cookie
      .split('; ')
      .find((row) => row.startsWith('settings='));

    if (cookieSettings) {
      const settings = JSON.parse(
        decodeURIComponent(cookieSettings.split('=')[1])
      );
      if (settings.language) {
        return settings.language.toLowerCase() === 'spanish' ? 'es' : 'en';
      }
    }

    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage) {
      return savedLanguage.toLowerCase() === 'spanish' ? 'es' : 'en';
    }

    return 'en';
  } catch (error) {
    console.error('Error getting initial language:', error);
    return 'en';
  }
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });
}

export default i18n;
